import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

const initialState: {
  order_id?: string
  country_code?: string
  currency?: string
  pub_key?: string
  session?: any
  success_url?: string
  fail_url?: string
} = {}

export type UpgradeCheckoutGetExtInfoParams = {
  order_id: string
  country_code: string
  currency: string
}

// checkout渠道前端页面获取额外信息接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=184776488
export const upgrade_checkout_get_ext_info = createAsyncThunk(
  '/live/pay/upgrade_checkout_get_ext_info',
  async (
    {order_id, country_code, currency}: UpgradeCheckoutGetExtInfoParams,
    store: any
  ) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/upgrade_checkout_get_ext_info',
      {
        is_upgrade: true,
        order_id,
        country_code,
        currency,
      },
      {
        store,
      }
    )
    return resp.data.data
  }
)

// checkout风控接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=184776533
export const upgrade_checkout_risk = createAsyncThunk(
  '/live/pay/upgrade_checkout_risk',
  async (
    data: {
      order_id: string
      data: any
    },
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<{
        redirect_url: string
        is_not_risk: boolean
        err_msg: string
      }>
    >('/live/pay/upgrade_checkout_risk', data, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)
export const Wallet2CheckoutFlowSlice = createSlice({
  name: 'Wallet2CheckoutFlow',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      upgrade_checkout_get_ext_info.fulfilled,
      (state, action) => {
        Object.assign(state, {
          ...action.payload,
          order_id: action.meta.arg.order_id,
          country_code: action.meta.arg.country_code,
          currency: action.meta.arg.currency,
        })
      }
    )
  },
})
export const Wallet2CheckoutFlowSliceActions = Wallet2CheckoutFlowSlice.actions
export default Wallet2CheckoutFlowSlice.reducer
export const useWallet2CheckoutFlowState = () => {
  const data = useSelector((state) => state.Animal_Leopard_flow)
  return data
}
